import { useState, useEffect } from 'react';

const useGeoLocation = () => {
  const [geoData, setGeoData] = useState({
    country: null,
    countryCode: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const detectCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) {
          throw new Error('Failed to fetch geo data');
        }
        const data = await response.json();
        
        setGeoData({
          country: data.country_name,
          countryCode: data.country_code,
          loading: false,
          error: null,
        });
      } catch (error) {
        console.error('Geo detection error:', error);
        setGeoData({
          country: null,
          countryCode: null,
          loading: false,
          error: error.message,
        });
      }
    };

    detectCountry();
  }, []);

  return geoData;
};

export default useGeoLocation;